module.exports = __webpack_public_path__ + "img/vertical_7_4_7005.54b66589.png";